import { BillingModel } from '@/modules/billing/entities/billing.enums';
import useCompany from '@/shared/hooks/useCompany/useCompany';

const { REACT_APP_BILLING_MODEL_DETECTION_ENABLED } = process.env

export const useBillingModel = () => {
  const { company } = useCompany();

  return REACT_APP_BILLING_MODEL_DETECTION_ENABLED === 'true' ? {
    companyBillingModel: company.billing?.model,
    isCompanyFeeForService: company.billing?.model === BillingModel.FEE_FOR_SERVICE,
    isCompanyFeeForLife: company.billing?.model === BillingModel.FEE_FOR_LIFE,
  } : {
    companyBillingModel: BillingModel.FEE_FOR_SERVICE,
    isCompanyFeeForService: true,
    isCompanyFeeForLife: false,
  }
}
